module.exports = __webpack_public_path__ + "assets/x2.a21aae13e6df5a4f77b68f4ceaff94d8.png";